let widgetContainerSelector;
let loadMethod;
let containerDetectInterval;

const initWidget = function () {
  const widgetContainer = document.querySelector(widgetContainerSelector);

  if (!widgetContainer) return false;

  if (containerDetectInterval) {
    clearInterval(containerDetectInterval);
  }

  if (widgetContainer.hasAttribute("data-v-app")) {
    console.error(
      "Frisbuy widget [stories] already mounted on page",
      widgetContainer
    );
    return;
  }

  if (loadMethod) {
    loadMethod(widgetContainer);
  }

  return true;
};

export const waitContainerLoad = (containerSelector, callback) => {
  widgetContainerSelector = containerSelector;
  loadMethod = callback;

  if (!initWidget()) {
    // re-check in 50 seconds
    setTimeout(() => {
      // if container is still not present - keep trying every 100 ms
      if (!initWidget()) {
        containerDetectInterval = setInterval(initWidget, 100);
        // stop waiting 3 secs after page load
        window.addEventListener("load", () => {
          setTimeout(() => {
            initWidget();

            if (containerDetectInterval) {
              clearInterval(containerDetectInterval);
            }
          }, 3000);
        });
      }
    }, 50);
  }
};
